import { ReportDTO } from '@nx-smartmonkey/shared/domain';
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { StopReport } from '../../domain/report/StopReport';
import { StopReportCreate } from '../../domain/report/StopReportCreate';
import { StopReportCreateMapper } from '../../mappers/report/StopReportCreateMapper';
import { StopReportMapper } from '../../mappers/report/StopReportMapper';
import { SessionRepository } from '../session/SessionRepository';
import { ReportRepository } from './ReportRepository';

export class ReportRepositoryApi implements ReportRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async createReport(stopReportCreate: StopReportCreate): Promise<StopReport> {
    const { stop_id, type, images, ...stopReportCreateRepositoryDTO } =
      StopReportCreateMapper.toRepository(stopReportCreate);

    const formData = new FormData();
    formData.append(`report_params`, JSON.stringify(stopReportCreateRepositoryDTO));
    if ((images ?? []).length > 0) {
      const filesMetadata: { name: string; mime: string }[] = [];
      (images ?? []).forEach((image, index) => {
        const metadata = {
          name: image.file_name,
          mime: image.mime_type,
        };
        filesMetadata.push(metadata);
        formData.append(`file_${index}`, image.data);
      });
      formData.append(`files_metadata`, JSON.stringify(filesMetadata));
    }

    const urlParams = new URLSearchParams();
    urlParams.append(`status`, type);

    const response = await this.requests.post({
      uri: `/drivers/v3/stop/${stop_id}/report?${urlParams.toString()}`,
      data: formData,
      headers: {
        'content-type': `multipart/form-data`,
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });
    return StopReportMapper.toDomain(response.data as ReportDTO);
  }

  async discardReport(stopReport: StopReport): Promise<void> {
    if (!stopReport.id) {
      throw new Error(`Stop report not found`);
    }

    await this.requests.delete({
      uri: `/drivers/v3/stop/${stopReport.stop_id}/report/${stopReport.id}`,
      headers: {
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });
  }
}
